import { render, staticRenderFns } from "./FeedContentInfoStatuses.vue?vue&type=template&id=0e4ec427&"
import script from "./FeedContentInfoStatuses.vue?vue&type=script&lang=ts&"
export * from "./FeedContentInfoStatuses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports